/*
 * QuickActions — Stage-14 Home rebuild.
 *
 * The user brief, verbatim:
 *   "ZONE 3 — Quick Actions. Only 3 buttons: Ask Kindra · Upload report ·
 *    Prepare appointment."
 *
 * Three buttons. No more. No less. Calm typography, secondary visual weight
 * so it doesn't compete with the Today's One Thing card above.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChatCircleDots, UploadSimple, CalendarBlank } from '@phosphor-icons/react';

const ACTIONS = [
  { key: 'ask',    label: 'Ask Kindra',          icon: ChatCircleDots, path: '/chat' },
  { key: 'upload', label: 'Upload report',       icon: UploadSimple,   path: '/documents' },
  { key: 'prep',   label: 'Prepare appointment', icon: CalendarBlank,  path: '/appointments' },
];

export const QuickActions = () => {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-3 gap-2.5" data-testid="quick-actions">
      {ACTIONS.map(({ key, label, icon: Icon, path }) => (
        <button
          key={key}
          type="button"
          onClick={() => navigate(path)}
          className="flex flex-col items-center justify-center gap-1.5 rounded-xl border border-[#ECE8E1] bg-white px-3 py-3.5 hover:border-[#CFC8BB] hover:bg-[#FBFAF6] transition-colors"
          data-testid={`quick-action-${key}`}
        >
          <Icon size={20} className="text-[#235347]" weight="duotone" />
          <span className="text-[12.5px] font-medium text-[#0E1C2E] leading-tight text-center">
            {label}
          </span>
        </button>
      ))}
    </div>
  );
};

export default QuickActions;
